import styled from "styled-components";
import ArrowRight from "../../../assets/images/ems/arrow-right.png";

export const BoxWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border: 1px solid #D5D8DE;
  border-radius: 6px;
  padding: 15px;
  ${({ height }) => height && `height: ${height};`}

  & .line {
    position: absolute;
    top: 55px;
    left: 143px;
    width: 715px;
    height: 143px;
    border: 2px solid var(--color-primary);

    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      transform: translate(-50%, -50%);
      width: 33px;
      height: 15px;
      background-color: #fff;
      background-image: url(${ArrowRight});
      background-size: 80%;
      background-repeat: no-repeat;
      background-position: center;
    }
  }
`;
export const ProjectTitle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 78px;
  background-color: var(--grey-100);

  & > div {
    width: 1200px;
    font-size: 20px;
    font-weight: bold;
  }
`;

export const ContentContainer = styled.div`
  width: 1176px;
  margin: 30px auto;
`;

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: ${({ girdFr }) => girdFr || "1fr 1fr 1fr"};
  gap: 15px;
  margin-bottom: 20px;
`;